
export default function asset( state = [], action = {} ){

	switch( action.type ){
		case 'SAVE_ASSET':
			return action.asset
		case 'GET_ASSETS':
			return action.asset
		case 'DELETE_ASSETS':
			return action.asset
		case 'UPDATE_ASSETS':
			return action.asset
		case 'UPLOADED_ASSET_DOCS':
			return action.asset
		case 'DELETE_DOCS':
			return action.asset
		default: return state;
	}
		
}




// WEBPACK FOOTER //
// ./src/store/reducers/assets/asset.reducer.js